enum STATUT_INDISPONIBILITE_TEMPORAIRE {
  EN_COURS_PLANIFIEE = "En cours / Planifiée",
  EN_COURS = "En cours",
  PLANIFIEE = "Planifiée",
  TERMINEE = "Terminée",
}

export default STATUT_INDISPONIBILITE_TEMPORAIRE;
